import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.element.querySelectorAll('video').forEach(video => {
      video.poster = '/images/glamorous-christmas/poster.png'
      video.muted = true
      video.playsInline = true
      video.autoplay = true
      video.addEventListener('click', this.toggleFullscreen.bind(this))
    })
  }

  toggleFullscreen(event) {
    event.preventDefault()
    event.stopPropagation()

    const video = event.currentTarget

    if (document.fullscreenElement) {
      document.exitFullscreen()
    } else {
      video.requestFullscreen()
    }
  }

  disconnect() {
    this.element.querySelectorAll('video').forEach(video => {
      video.removeEventListener('click', this.toggleFullscreen.bind(this))
    })
  }
}
